import type { AdminTicketDto } from '../api';

/** The same enabled + cutoff rule that decides whether buyers pay the Early Bird price. */
export function isEarlyBirdActive(enabled: boolean, effectiveUntil: string, now = Date.now()): boolean {
  const cutoff = Date.parse(effectiveUntil);
  return enabled && Number.isFinite(cutoff) && now < cutoff;
}

/** Use the canonical sale phase for public badges; organizer-provided taglines are copy, not state. */
export function publicPhaseLabel(phase: 'early-bird' | 'regular'): 'EARLY BIRD' | 'REGULAR' {
  return phase === 'early-bird' ? 'EARLY BIRD' : 'REGULAR';
}

/** Total potential value at the price buyers can pay right now, across the configured capacity. */
export function currentTicketValue(tickets: readonly Pick<AdminTicketDto, 'capacity' | 'priceEarly' | 'priceRegular'>[], earlyBirdActive: boolean): number {
  return tickets.reduce((sum, ticket) => {
    const price = earlyBirdActive && ticket.priceEarly > 0 ? ticket.priceEarly : ticket.priceRegular;
    return sum + ticket.capacity * price;
  }, 0);
}
